import { useRef } from 'react';

type CommandKind = 'plan' | 'actual' | 'cancel';
type StoredId = { bookingId: string | undefined; value: string };

export function useEarlyDepartureCommandIds(bookingId: string | undefined) {
  const ids = useRef<Partial<Record<CommandKind, StoredId>>>({});

  const get = (kind: CommandKind) => {
    const stored = ids.current[kind];
    if (stored && stored.bookingId === bookingId) return stored.value;
    const value = crypto.randomUUID();
    ids.current[kind] = { bookingId, value };
    return value;
  };
  const reset = (...kinds: CommandKind[]) => {
    for (const kind of kinds) delete ids.current[kind];
  };

  return { get, reset };
}
